import React, { Component } from "react";
import { connect } from "react-redux";
import { SEASON_ID, CURRENT_WEEK, TEAM_PARTICIPATION } from "config";
import PageContainer from "pages/container";
import TabBar from "components/tab-bar";
import SubNavTab from "components/sub-nav-tab";
import StandingsTable from "components/standings-table";
import LoadingBar from "components/loading-bar";
import { getStandingsRequest } from "actions/pages/standings";

const TAB_WEEK_1 = {
  id: 1,
  title: "W1",
};

const TAB_WEEK_2 = {
  id: 2,
  title: "W2",
};

const TAB_WEEK_3 = {
  id: 3,
  title: "W3",
};

const TAB_WEEK_4 = {
  id: 4,
  title: "W4",
};

const TAB_WEEK_5 = {
  id: 5,
  title: "W5",
};

// const TAB_WEEK_6 = {
//   id: 6,
//   title: "W6",
// };

// const TAB_WEEK_7 = {
//   id: 7,
//   title: "W7",
// };

// const TAB_WEEK_8 = {
//   id: 8,
//   title: "W8",
// };

const TABS = [
  TAB_WEEK_1,
  TAB_WEEK_2,
  TAB_WEEK_3,
  TAB_WEEK_4,
  TAB_WEEK_5,
  // TAB_WEEK_6,
  // TAB_WEEK_7,
  // TAB_WEEK_8,
];

class Standings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: TABS.find((t) => t.id === CURRENT_WEEK) || TAB_WEEK_5,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { selectedTab } = this.state;

    const week = selectedTab.id;

    dispatch(getStandingsRequest(SEASON_ID, week));
  }

  selectTab = (tab) => {
    const { dispatch } = this.props;
    const { selectedTab } = this.state;

    const week = tab.id;

    if (selectedTab !== tab) {
      this.setState(
        {
          selectedTab: tab,
        },
        () => {
          dispatch(getStandingsRequest(SEASON_ID, week));
        }
      );
    }
  };

  render() {
    const { page } = this.props;
    const { standings, requests } = page;
    const { selectedTab } = this.state;

    let content;

    if (requests.getStandings.success) {
      let atLeastOneTeamWithPoints = standings.teams.filter(
        (s) => s.points.total > 0
      ).length;

      if (standings && atLeastOneTeamWithPoints) {
        content = (
          <div className="content">
            <StandingsTable
              type="twcd"
              teams={standings.teams.filter((t) =>
                TEAM_PARTICIPATION.twld.includes(t.fnTeamID)
              )}
            />
            <StandingsTable
              type="twcj"
              teams={standings.teams.filter((t) =>
                TEAM_PARTICIPATION.twlj.includes(t.fnTeamID)
              )}
            />
            <StandingsTable
              type="twcb"
              teams={standings.teams.filter((t) =>
                TEAM_PARTICIPATION.twlb.includes(t.fnTeamID)
              )}
            />
          </div>
        );
      } else {
        content = <p className="intro">No standings available.</p>;
      }
    } else {
      content = <LoadingBar />;
    }

    return (
      <PageContainer
        title="Standings"
        subtitle="These are the standings for the Regular Season"
        className="standings"
      >
        <TabBar>
          {TABS.map((tab) => (
            <SubNavTab
              key={tab.id}
              {...tab}
              onClick={() => {
                this.selectTab(tab);
              }}
              selected={selectedTab === tab}
            />
          ))}
        </TabBar>
        {content}
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
  page: state.pages.standings,
});

export default connect(mapStateToProps)(Standings);



// WEBPACK FOOTER //
// ./src/pages/standings/standings.js